import { useSession } from "@src/appV2/Auth/api/useSession";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import constate from "constate";
import { hasAnyTrueValue } from "./utils";

export interface WorkerMenuPrivileges {
  dashboard?: boolean;
  chat?: boolean;
  chatRedesign?: boolean;
  dnr?: boolean;
  payrollSection?: {
    payroll: boolean;
    stripeTransfers: boolean;
    stripePayouts: boolean;
  };
  clipboardScore?: boolean;
  placementSection?: { candidateProfile: boolean; exclusions: boolean };
}

export function useGetWorkerMenuPrivileges(): WorkerMenuPrivileges {
  const { type } = useSession();
  const isChatRedesignEnabled = useCbhFlag(CbhFeatureFlag.CHAT_REDESIGN_ENABLED, {
    defaultValue: false,
  });

  const isWorker = type === "AGENT";
  if (!isWorker) {
    return {};
  }

  const dashboard = true;

  const chat = true;
  const chatRedesign = chat && isChatRedesignEnabled;

  const dnr = true;

  const payroll = true;
  const stripeTransfers = true;
  const stripePayouts = true;
  const payrollSection = { payroll, stripeTransfers, stripePayouts };

  const clipboardScore = true;

  const candidateProfile = true;
  const exclusions = true;
  const placementSection = { candidateProfile, exclusions };

  return {
    dashboard,
    chat,
    chatRedesign,
    dnr,
    payrollSection: hasAnyTrueValue(payrollSection) ? payrollSection : undefined,
    clipboardScore,
    placementSection: hasAnyTrueValue(placementSection) ? placementSection : undefined,
  };
}

export const [WorkerMenuPrivilegesProvider, useWorkerMenuPrivilegesProviderContext] = constate(
  useGetWorkerMenuPrivileges
);
